import { render, staticRenderFns } from "./PortalOffline.vue?vue&type=template&id=da5d8a16&scoped=true"
import script from "./PortalOffline.vue?vue&type=script&lang=ts"
export * from "./PortalOffline.vue?vue&type=script&lang=ts"
import style0 from "./PortalOffline.vue?vue&type=style&index=0&id=da5d8a16&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack@5.98._lpz7yfflcfbikbc3glhfyeagle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5d8a16",
  null
  
)

export default component.exports